import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_ProceduresAcknowledgement = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_ProceduresAcknowledgement' className='file-pdf-document'>
            <div className='file-template'>
            <p className='w-750'> <h3>Client Receipt of Orientation and Understanding of Policies and Procedures Acknowledgement</h3></p>
            <p className='w-750'><h4>Receipt of Client Orientation</h4></p>
<p className='w-750'>{`By singning below, I acknowledge that I have received an orientation to Right Path Behavioral
    Health Services (RPBHS), have had the opportunity to ask questions about the RPBHS Client 
    Orientation Handbook that includes but is not limited to an explanatin of my rights and responsibilities,
    complaint/grievance procedure, confidentiality, program rules, policies and procedures, and behavioral expectations.
    By signing below, I also acknowledge that I am aware of the full array of services available at RPBHS.`}</p>
<p className='w-750'><h4>Understanding of Policies and Procedures</h4></p>
<p className='w-750'>{`By signing below, I agree to actively participate in the intake process and agreed upon treatment plan, 
    to take my prescribed medications as recommended, and to participate in school or school related activities
    (if appropriate). By signing below, I also acknowledge receipt and understanding of
    RPBHS policies regarding weapons, alcohol, legal drugs, illegal drugs, over-the-counter drugs,
    tabacco products, e-cigarettes, and vapes.`}</p>
<p className='w-750'>{`By signing below, I also acknowledge understanding that services provided by RPBHS are voluntary and that
    I give consent for RPBHS to contact me for the purposes of obtaining follow up information 
    concerning my progress during and after completing services.`}</p>
    <table>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                        
                    </tr>
                    <tr>
                        <td className='small w-750'> Signature </td>
                        
                    </tr>
                </table>



                
            </div>
        </form>

    )
}











